import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { FieldConfig } from 'src/app/modules/_models/field.interface';

@Component({
  selector: 'app-card-carousel',
  template: `
    <div
      class="card-carousel_container"
      *ngIf="field.srcList && field.titleList && field.descriptionLabel"
    >
      <div class="coracao_content">
        <span class="fa fa-heart coracao_icone"></span>
        <label
          class="cs_label detail_label"
          [innerHtml]="field.detailLabel | linkify"
        ></label>
      </div>
      <div class="imagem_container">
        <span
          class="botao_esquerda desktop-botoes voltar_desktop_botao fa fa-chevron-circle-left fa-2x apenas--desktop"
          (click)="carregarAnterior()"
          [hidden]="id == 0"
        ></span>
        <img class="imagem" [src]="transform()" />
      </div>
      <div class="footer_container">
        <div>
          <label
            class="cs_label label_titulo"
            [innerHtml]="
              field.titleList!.length > 1
                ? field.titleList[id]
                : (field.titleList[0] | linkify)
            "
          ></label>
          <label
            class="cs_label label_descricao"
            [innerHtml]="
              field.descriptionLabel!.length > 1
                ? field.descriptionLabel[id]
                : (field.descriptionLabel[0] | linkify)
            "
          ></label>
          <button
            class="cs_botao"
            *ngIf="field.buttonLabels[id]"
            (click)="irParaPagina()"
          >
            {{
              field.buttonLabels!.length > 1
                ? field.buttonLabels[id]
                : field.buttonLabels[0]
            }}
          </button>
        </div>
        <span
          class="botao_direita avancar_desktop_botao desktop-botoes fa fa-chevron-circle-right fa-2x apenas--desktop"
          (click)="carregarProximo()"
          [hidden]="id == field.titleList.length - 1"
        ></span>
      </div>
      <div class="botao_imagens_container apenas--mobile">
        <div>
          <span
            class="botao_esquerda fa fa-chevron-circle-left fa-2x"
            (click)="carregarAnterior()"
            [hidden]="id == 0"
          ></span>
        </div>
        <div>
          <span
            class="botao_direita fa fa-chevron-circle-right fa-2x"
            (click)="carregarProximo()"
            [hidden]="id == field.titleList.length - 1"
          ></span>
        </div>
      </div>
    </div>
  `,
  styleUrls: ['./card-carousel.component.scss'],
})
export class CardCarouselComponent implements OnInit {
  field: FieldConfig;
  group: UntypedFormGroup;
  id: number = 0;

  constructor(private route: Router, private sanitizer: DomSanitizer) {}
  ngOnInit() {
    this.carregarComponente();
  }

  carregarComponente(): void {
    setInterval(() => {
      this.id != this.field.titleList.length - 1
        ? (this.id += 1)
        : (this.id = 0);
    }, 10000);
  }

  carregarProximo(): void {
    if (this.id != this.field.titleList.length - 1) this.id += 1;
  }
  carregarAnterior(): void {
    if (this.id != 0) this.id -= 1;
  }

  irParaPagina(): void {
    if (!this.field.link[this.id]) return;

    if (
      !this.field.link[this.id].includes('https') &&
      !this.field.link[this.id].includes('http')
    ) {
      this.route.navigate([this.field.link[this.id]]);
      return;
    }

    window.open(this.field.link[this.id], '_blank');
  }

  transform() {
    // var imagem = this.sanitizer.bypassSecurityTrustResourceUrl('data:image/jpeg;base64,' + this.field.srcList[this.id]);
    var imagem = this.field.srcList[this.id];
    return imagem;
  }
}
